import { Routes } from '@angular/router'

export const interactionRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/'
  },

  {
    path: 'free/:interactionId',
    loadComponent: () =>
      import('./free-mode/interaction-free-mode.component').then(
        (m) => m.InteractionFreeModeComponent
      ),
    data: { workflow: 'domain' }
  },

  {
    path: 'issue/:interactionId',
    loadComponent: () =>
      import('./failure-mode/interaction-failure-mode.component').then(
        (m) => m.InteractionFailureModeComponent
      ),
    data: { workflow: 'coty' }
  },

  { path: '**', redirectTo: '/', pathMatch: 'full' }
]
